import { InputLabel, Stack } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';

interface SettingDateTimeFieldProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  label?: string;
  minDateTime?: Date;
  disabled?: boolean;
  timezone?: string;
}

const SettingDateTimeField: React.FC<SettingDateTimeFieldProps> = ({
  value,
  onChange,
  label = 'Date/Time',
  minDateTime,
  disabled = false,
  timezone,
}) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={3}
    alignItems={{ xs: 'stretch', sm: 'center' }}>
    <InputLabel
      sx={{
        minWidth: { xs: 0, sm: 130 },
        color: 'text.primary',
        fontWeight: 500,
        mb: { xs: 1, sm: 0 },
      }}>
      {label}
    </InputLabel>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        value={value}
        onChange={onChange}
        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
        minDateTime={minDateTime}
        disabled={disabled}
        ampm={false}
        timezone={timezone}
      />
    </LocalizationProvider>
  </Stack>
);

export default SettingDateTimeField;
